<template>
    <div>
        <table width="100%" class="basket-table">
            <tr v-if="basketMessages">
                <th v-for="item in basketMessages.columns">
                    {{item}}
                </th>
            </tr>
            <basket-page-product-item v-for="item in getBasketItems" :item="item"
                                      :key="item.productId"></basket-page-product-item>
            <tr>
                <td v-if="basketMessages" colspan="6">
                    <div class="bot-table">
                        <div class="total-order">
                            <div class="label">{{basketMessages.totalPriceTitle}}</div>
                            <div class="total-price"> {{getTotalPrice}}</div>
                        </div>
                        <a v-if="basketMessages.isAuthorized == 'N'" class="btn btn-std need-auth" data-toggle="modal"
                           data-target="#sign-in" href="javascript:;">{{basketMessages.makeOrder}}</a>
                        <div v-else>
                            <a v-if="view_settings != '1'" :href="basketMessages.checkoutLink" class="btn btn-std">
                                {{basketMessages.makeOrder}}
                            </a>
                            <button v-else :disabled="true" class="btn btn-std">
                                {{basketMessages.makeOrder}}
                            </button>
                        </div>
                    </div>
                    <div class="basket-view-settings" v-if="view_settings == '1'">{{basketMessages.viewSettings}}</div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import BasketItem from "vueComponents/product/basket/BasketItem";

    /**
     * Контейнер для отображения корзины товаров.
     *
     *  - basketItems информация о товарах корзины
     *  - basketTotalSum стоимость товаров в корзине
     *  - basketMessages статический текст для отображение в корзине выдаваемый бэком в зависемости от языка
     *  - currency валюта товара
     *   <basket-page-product-item> - конкретный товар в корзине
     * @vuedoc
     * @module vue:containers/Basket
     * @exports vue:containers/Basket
     */
    export default {
        name: "basket-page",

        components: {
            'basket-page-product-item': BasketItem,
        },

        props: ['view_settings'],

        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {object} basketData - Информауия товарах в корзине
         */
        data() {
            return {
                basketData: {},
            }
        },

        computed: {
            ...mapGetters('basket', [
                'basketItems',
                'basketTotalSum',
                'basketMessages'
            ]),

            /**
             *  Вычисляемое свойство возвражает товары в корзине паралельно сохраняя их список в переменной this.basketData
             *
             * @method getBasketItems
             */
            getBasketItems() {
                if (typeof this.basketItems !== 'undefined') {
                    this.basketData = this.basketItems;
                    return this.basketData;
                }
            },

            /**
             *  Вычисляемое свойство возвражает общую стоимость товаров в корзине
             *
             * @method getTotalPrice
             */
            getTotalPrice() {
                if (typeof this.basketTotalSum !== 'undefined') {
                    return this.basketTotalSum;
                }
            }

        },
        mounted() {
        },
        methods: {}
    }


</script>
